<template>
  <div class="backdrop">
    <div class="uploader">
      <div>Uploading...</div>
      <div class="text-center">
        <Loader />
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/UI/loaders/Loader'

export default {
  components: {
    Loader,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.backdrop {
  top: 0;
  left: 0;
  z-index: 90;
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  background-color: rgba($color: $black-color, $alpha: 0.3);
}

.uploader {
  padding: 1.5rem;
  font-weight: bold;
  border-radius: 8px;
  background-color: $white-color;
}

</style>
